import styled from "styled-components"

export default function InputBase({ children, wrapperStyle, ...rest }) {
  return (
    <Block {...rest} wrapperStyle={wrapperStyle}>
      {children}
    </Block>
  )
}

const Block = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ wrapperStyle }) => wrapperStyle && wrapperStyle}
`
